import { connect } from 'react-redux';
import type { Facet, OverrideValues, AccommodationState, RatingFacet } from '@/interfaces';
import { actions } from '@/state/filterActions';
import { fetchHotels } from '@/ducks/searchResults/actions';
import { type CheckboxDispatchProps, CheckboxFilter, type CheckboxStateProps } from '@/components/checkboxFilter/CheckboxFilter';
import type { ActionCreator } from 'redux';
import displayValues from '../../../../../../assets/displayValues.json';

const mapGuestRatings = (starRatings: RatingFacet[]): Facet[] =>
    starRatings.sort((a, b) => b.key - a.key).map((rating) => ({ value: rating.key.toString(), count: rating.value }));

export const mapStateToProps = (state: AccommodationState): CheckboxStateProps => ({
    id: 'GuestRatingFilter',
    label: 'Gjestevurderinger',
    facetList: mapGuestRatings([...state.searchResults.guestRatings]),
    displayValues: displayValues.guestRatings,
    checkboxValues: state.filters.guestRating,
    hideLabel: true,
    alwaysExpanded: true,
});

export const mapDispatchToProps: OverrideValues<CheckboxDispatchProps, ActionCreator<unknown>> = {
    checkBoxClick: actions.filterGuestRating,
    triggerFetch: fetchHotels,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckboxFilter);
